import { ToastOptions, ToastContainerProps, Slide } from 'react-toastify';

export const toastFunctionConfig: ToastOptions = {
  icon: false,
  style: {
    backgroundColor: 'transparent', // Mantener transparente para que se vea el fondo del componente
    width: 'max-content',
    boxShadow: 'none',
    right: 75,
    top: 50,
    position: 'relative',
    marginBottom: '1rem',
    animationDuration: '0.4s',
    padding: 0, // Sin padding para que el componente controle todo el estilo
  },
};

export const toastContainerConfig: ToastContainerProps = {
  position: 'top-right',
  autoClose: 8000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  closeButton: false,
  theme: 'light',
  transition: Slide,
  style: {
    zIndex: 100001, // Mayor que el z-index del modal (100000) para que aparezca por encima
  },
};
